module.exports = Plyr;


//////////////////
// WEBPACK FOOTER
// external "Plyr"
// module id = v/iG
// module chunks = 1